import { render } from "./CargoSelect.vue?vue&type=template&id=2370c5d9"
import script from "./CargoSelect.vue?vue&type=script&lang=js"
export * from "./CargoSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__